import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TestImage } from 'src/app/pages/virtual-class/interfaces';
import { ParamServicesService } from 'src/app/services/param-services.service';

@Component({
  selector: 'app-continue-to-pay',
  templateUrl: './continue-to-pay.component.html',
  styleUrls: ['./continue-to-pay.component.scss'],
})
export class ContinueToPayComponent implements OnInit {
  @Input() type:
    | 'pendingPayModule'
    | 'blockedTest'
    | 'condicionalDate'
    | 'condicionalDues'
    | 'condicionalModuleId'
    | 'condicionalTestId'
    | 'congratulations';

  @Input() showCancelBtn = true;
  @Input() extraMsg = '';
  public testImage: TestImage;

  constructor(
    private paramSv: ParamServicesService,
    private modalCtr: ModalController
  ) {}

  ngOnInit() {
    this.testImage = this.paramSv.testImages.find((x) => x.name === this.type);
    if (this.testImage.fullscreen) {
      const modal = document.querySelector('ion-modal.continue-to-pay');
      modal.setAttribute('style', '--height: 100%; --width: 100%');
    }
  }

  async doAction(action) {
    await this.modalCtr.dismiss(action);
  }
}
